<div class="batch-view-wrapper">
  @if (isEditable) {
    <section class="checkbox">
      <input
        type="checkbox"
        [id]="'selected_card' + departureAttachment.id"
        [ngModel]="departureAttachment.selected"
        (ngModelChange)="changeSelected($event)"
      />
      <label [for]="'selected_card' + departureAttachment.id">
        <div class="checkbox__el"></div>
      </label>
    </section>
  }

  <article
    class="batch-view-card"
    [ngClass]="isEditable && 'pointer'"
    (click)="openAddAttachmentModal()"
    [ngStyle]="{ width: isEditable ? 'calc(100% - 16px - 16px)' : '100%' }"
  >
    <section class="batch-view-card-sections">
      <div class="batch-view-card-sections-item">
        <span class="batch-view-card-item-title">{{
          'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.ARTICLE'
            | translate
            | uppercase
        }}</span>
        <span class="batch-view-card-item-value">{{
          departureAttachment.article || '-'
        }}</span>
      </div>

      <div class="batch-view-card-sections-item">
        <span class="batch-view-card-item-title">{{
          'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.PRODUCT_NAME'
            | translate
            | uppercase
        }}</span>
        <span
          [tooltip]="
            departureAttachment.name.length > 30 ? departureAttachment.name : ''
          "
          class="batch-view-card-item-value width300"
          >{{ departureAttachment.name || '-' }}</span
        >
      </div>

      <div class="batch-view-card-sections-item">
        <span class="batch-view-card-item-title">{{
          'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.COST'
            | translate
            | uppercase
        }}</span>
        <span class="batch-view-card-item-value">{{
          departureAttachment.price || '-'
        }}</span>
      </div>

      <div class="batch-view-card-sections-item">
        <span class="batch-view-card-item-title">{{
          'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.PRODUCT_QUANTITY'
            | translate
            | uppercase
        }}</span>
        <span class="batch-view-card-item-value">{{
          departureAttachment.quantity || '-'
        }}</span>
      </div>

      <div class="batch-view-card-sections-item">
        <span class="batch-view-card-item-title">{{
          'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.TOTAL_COST'
            | translate
            | uppercase
        }}</span>
        <span class="batch-view-card-item-value">{{
          departureAttachment.total_price || '-'
        }}</span>
      </div>

      @if (isEditable) {
        <button
          type="button"
          class="filter-button action-button"
          stopPropagation
          (click)="deleteAttachments.emit(departureAttachment.id)"
        >
          <fa-icon class="red" [icon]="faTrashAlt"> </fa-icon>
        </button>
      }
    </section>
  </article>
</div>
